import CanvasEngine from "./CanvasEngine";
export default class DRCLibrary {
  constructor(canvasEngine) {
    this.engine = canvasEngine;
    this.violations = [];
    this.visibleViolations = [];
    this.violationIndex = -1;
    this.violationStyles = {
      edge: { strokeStyle: '#ff0000', lineWidth: 2, lineDash: [], fillStyle: 'red' },
      polygon: { strokeStyle: 'rgba(255, 0, 0, 0.7)', fillStyle: 'rgba(255, 0, 0, 0.3)', lineWidth: 1, lineDash: [] }
    };
  }

//     drawViolation(violation) {
//   if (!violation || !violation.location) return;

//   this.visibleViolations = [violation];
//   this.violationIndex = 0;
//   this.renderViolations();
// }
  drawViolation(violation, groupViolations = null) {
  if (!violation || !violation.location) return;

  // Store group as working set
  if (groupViolations && Array.isArray(groupViolations)) {
    this.violations = groupViolations;
  } else {
    this.violations = [violation];
  }

  // find clicked violation index
  this.violationIndex = this.violations.findIndex(v =>
    JSON.stringify(v.location) === JSON.stringify(violation.location) &&
    v.type === violation.type
  );
  if (this.violationIndex === -1) this.violationIndex = 0;

  this.visibleViolations = [this.violations[this.violationIndex]];
  this.renderViolations();

  if (this.engine?.smoothZoomToViolation) {
    this.engine.smoothZoomToViolation(this.visibleViolations[0]);
  }
}


  drawAllViolations(violations = this.violations) {
  this.violations = violations;
  this.visibleViolations = [...violations];
  this.violationIndex = -1;
  this.renderViolations();
}


// clearViolations(ruleNames = null) {
//   if (ruleNames && Array.isArray(ruleNames)) {
//     this.violations = this.violations.filter(v => !ruleNames.includes(v.rule_name));
//     this.visibleViolations = this.visibleViolations.filter(v => !ruleNames.includes(v.rule_name));
//   } else {
//     this.violations = [];
//     this.visibleViolations = [];
//   }

//   this.violationIndex = -1;
//   this.renderViolations();
// }

clearViolations(ruleNames = null) {
  if (ruleNames && Array.isArray(ruleNames)) {
    const ruleSet = new Set();
    const groupSet = new Set();

    ruleNames.forEach(name => {
      if (name.includes("__")) {
        groupSet.add(name); // "SPACING__0"
      } else {
        ruleSet.add(name); // "SPACING"
      }
    });

    const filterFn = (v) => {
      const rule = v.rule_name;
      const groupIndex = v.group_index;
      const groupKey = typeof groupIndex !== "undefined" ? `${rule}__${groupIndex}` : null;

      if (ruleSet.has(rule)) return false;
      if (groupKey && groupSet.has(groupKey)) return false;
      return true;
    };

    this.violations = this.violations.filter(filterFn);
    this.visibleViolations = this.visibleViolations.filter(filterFn);
  } else {
    this.violations = [];
    this.visibleViolations = [];
  }

  this.violationIndex = -1;
  this.renderViolations();
}




highlightNextViolation() {
  if (!this.violations || this.violations.length === 0) return;

  this.violationIndex = (this.violationIndex + 1) % this.violations.length;
  const current = this.violations[this.violationIndex];

  this.visibleViolations = [current];
  this.renderViolations();
   // 👇 Smooth zoom on current violation
  if (this.engine?.smoothZoomToViolation) {
    this.engine.smoothZoomToViolation(current);
  }
}

highlightPrevViolation() {
  if (!this.violations || this.violations.length === 0) return;

  this.violationIndex = (this.violationIndex - 1 + this.violations.length) % this.violations.length;
  const current = this.violations[this.violationIndex];

  this.visibleViolations = [current];
  this.renderViolations();
   // 👇 Smooth zoom on current violation
  if (this.engine?.smoothZoomToViolation) {
    this.engine.smoothZoomToViolation(current);
  }
}



setHighlightColor(color) {
  this.violationStyles.edge.strokeStyle = color;
  this.violationStyles.edge.fillStyle = color;

  this.violationStyles.polygon.strokeStyle = color;
  // this.violationStyles.polygon.fillStyle = color;

  this.renderViolations(); // Refresh canvas with updated color
}



// Then add this new method to the class:
renderViolations() {
  const ctx = this.engine.ctx;
  ctx.save();
  // ctx.translate(this.engine.offsetX, this.engine.offsetY);
  // ctx.scale(this.engine.scale, -this.engine.scale);

  this.visibleViolations.forEach(violation => {
    const style = this.violationStyles[violation.type] || this.violationStyles.edge;

    ctx.strokeStyle = style.strokeStyle;
    ctx.fillStyle = style.fillStyle;
    // ctx.lineWidth = style.lineWidth;
    ctx.lineWidth = (style.lineWidth || 1) / this.engine.scale;
    ctx.setLineDash(style.lineDash);

    if (violation.type === 'edge' && violation.location.length >= 2) {
  const [p1, p2] = violation.location;
  if (p1[0] === p2[0] && p1[1] === p2[1]) {
    // Same point → draw a marker
    this.drawPoint(ctx, p1, style);
  } else {
    this.drawArrow(ctx, p1, p2, style);
  }
} else if (violation.type === 'polygon' && violation.location.length >= 2) {
      this.drawPolygon(ctx, violation.location);
    }
  });

  ctx.restore();
}


// Updated drawing methods
// drawArrow(ctx, p1, p2, style) {
//   const headLength = 10;
//   const angle = Math.atan2(p2[1] - p1[1], p2[0] - p1[0]);

//   // Line
//   ctx.beginPath();
//   ctx.moveTo(p1[0], p1[1]);
//   ctx.lineTo(p2[0], p2[1]);
//   ctx.stroke();

//   // Arrowhead
//   ctx.beginPath();
//   ctx.moveTo(p2[0], p2[1]);
//   ctx.lineTo(
//     p2[0] - headLength * Math.cos(angle - Math.PI/6),
//     p2[1] - headLength * Math.sin(angle - Math.PI/6)
//   );
//   ctx.lineTo(
//     p2[0] - headLength * Math.cos(angle + Math.PI/6),
//     p2[1] - headLength * Math.sin(angle + Math.PI/6)
//   );
//   ctx.closePath();
//   ctx.fillStyle = style.fillStyle;
//   ctx.fill();
// }

transformPoint([x, y]) {
  return [
    this.engine.offsetX + x * this.engine.scale,
    this.engine.offsetY - y * this.engine.scale  // flip Y
  ];
}

drawPoint(ctx, point, style = {}) {
  // Draw in WORLD coordinates (before transformation)
  const [x, y] = point; // Use original coordinates, not transformed

  // Scale the point size with zoom level
  const baseRadius = style.baseRadius || 0.05; // Small value in world units
  const screenRadius = baseRadius * this.engine.scale;

  ctx.save();
  // Apply the same transformation as other elements
  ctx.translate(this.engine.offsetX, this.engine.offsetY);
  ctx.scale(this.engine.scale, -this.engine.scale);

  ctx.beginPath();
  ctx.arc(x, y, baseRadius, 0, 2 * Math.PI);
  ctx.fillStyle = style.fillStyle || 'red';
  ctx.fill();

  ctx.strokeStyle = style.strokeStyle || 'red';
  ctx.lineWidth = (style.pointLineWidth || 0.0001) * this.engine.scale;
  ctx.stroke();

  ctx.restore();
}






drawArrow(ctx, p1, p2, style) {
  const tp1 = this.transformPoint(p1);
  const tp2 = this.transformPoint(p2);

  ctx.beginPath();
  ctx.moveTo(tp1[0], tp1[1]);
  ctx.lineTo(tp2[0], tp2[1]);

  ctx.strokeStyle = style.strokeStyle || '#000';
  ctx.lineWidth = style.lineWidth || 1; // constant screen pixels
  ctx.stroke();
}

drawPolygon(ctx, points) {
  if (points.length < 2) return;

  const tp0 = this.transformPoint(points[0]);
  ctx.beginPath();
  ctx.moveTo(tp0[0], tp0[1]);

  for (let i = 1; i < points.length; i++) {
    const tp = this.transformPoint(points[i]);
    ctx.lineTo(tp[0], tp[1]);
  }

  if (points.length > 2) {
    ctx.closePath();
    ctx.fill();
  }

  ctx.strokeStyle = this.violationStyles.polygon.strokeStyle;
  ctx.lineWidth = this.violationStyles.polygon.lineWidth || 1;
  ctx.stroke();
}


//  drawArrow(ctx, p1, p2, style) {
//   // Line
//   ctx.beginPath();
//   ctx.moveTo(p1[0], p1[1]);
//   ctx.lineTo(p2[0], p2[1]);
//   ctx.strokeStyle = style.strokeStyle || '#000'; // Optional: set line color
//   ctx.lineWidth = style.lineWidth || 1;          // Optional: set line width
//   ctx.stroke();

//   // Arrowhead removed
// }


// drawPolygon(ctx, points) {
//   ctx.beginPath();
//   ctx.moveTo(points[0][0], points[0][1]);
  
//   for (let i = 1; i < points.length; i++) {
//     ctx.lineTo(points[i][0], points[i][1]);
//   }
  
//   if (points.length > 2) {
//     ctx.closePath();
//     ctx.fill();
//   }
//   ctx.stroke();
// }

  // other DRC-related logic...
}
